import { render, staticRenderFns } from "./km-doc-modal.vue?vue&type=template&id=106b73bd&scoped=true&"
import script from "./km-doc-modal.vue?vue&type=script&lang=ts&"
export * from "./km-doc-modal.vue?vue&type=script&lang=ts&"
import style0 from "./km-doc-modal.vue?vue&type=style&index=0&id=106b73bd&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b73bd",
  null
  
)

export default component.exports